import { ListPageLayout } from "@/components/list-page-layout";
import { usePageTitle } from "@/hooks/use-page-title";
import { PersonsDataTable } from "./persons-data-table";

export default function PersonListView() {
  usePageTitle("Person List View");

  return (
    <ListPageLayout
      pageType="persons::list"
      title="Person List View"
      className="max-w-full"
    >
      <PersonsDataTable />
    </ListPageLayout>
  );
}
